module.exports = __webpack_public_path__ + "media/images/sprites-472bce34255ddd76cc9048c7b71dea63.png";